import styled from 'styled-components'
import theme from '../../styles/theme'

const SearchWrapper = styled.div`
  display: flex;
  margin: 0 0 1rem 0;
`

const SearchLabel = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`

const SearchInput = styled.input`
  box-sizing: border-box;
  font-size: 1rem;
  line-height: 1;
  padding: 0.5rem 1rem;
  border: 3px solid ${theme.color.border};
  background-color: white;
  color: ${theme.color.text};
  border-radius: 4px 0 0 4px;
  height: 2.875rem;
  width: 100%;
`

const SearchBtn = styled.button`
  font-size: 1rem;
  line-height: 1;
  padding: 0.5rem 1.5rem;
  display: inline-block;
  appearance: none;
  color: ${theme.color.white};
  text-decoration: none;
  border-radius: 0 4px 4px 0;
  background-color: ${theme.color.action};
  border: 3px solid ${theme.color.action};
  cursor: pointer;
  vertical-align: middle;
  transition: background 0.1s ease, border 0.1s ease, color 0.1s ease;
  height: 2.875rem;
  max-height: 2.875rem;

  &:hover {
    background-color: ${theme.color.text};
    border-color: ${theme.color.text};
    text-decoration: underline;
    color: ${theme.color.action};
  }

  &:focus {
    outline: 3px solid ${theme.color.focus};
    outline-offset: 2px;
    border-radius: 0;
  }
`

export { SearchWrapper, SearchLabel, SearchInput, SearchBtn }
